import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getLocationDropdownList, getUserTypes } from './endpoints/action';
import { addUserSelector } from './endpoints/selector';
import Loader from '../common/Loader';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import Footer from '../common/Footer';
import Error from '../common/Message/error';
import Success from '../common/Message/success';
import ContactForm from './contactForm';
import { useLocation } from 'react-router-dom';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import Spinner from '../common/Spinner/spinner';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const location = useLocation();
  const { addContacts, editUser, userDetails, name, locationName } =
    location.state;
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const { locationDropdownList, userTypes, successMessage, errorMessage,loadingFlag } =
    useSelector(addUserSelector);
  const [locationsDropdownList, setLocationDropdownList] = useState([]);
  const [userTypesList, setUserTypesList] = useState([]);
  const [usersDetail, setUsersDetail] = useState([]);
  const [locationId, setLocation] = useState();
  const dispatch = useDispatch();

  console.log(locationName);

  useEffect(() => {
    document.title = 'Employers Section';
    if (config.baseUrl) {
      dispatch(getUserTypes(config.baseUrl));
      dispatch(getLocationDropdownList(config.baseUrl, login.employerId));
    }
  }, [config]);

  useEffect(() => {
    if (!editUser) {
      setUsersDetail([]);
    }
  }, [editUser]);

  useEffect(() => {
    if (locationDropdownList.length > 0) {
      setLocationDropdownList(locationDropdownList);
    }
  }, [locationDropdownList]);

  useEffect(() => {
    if (userTypes.length > 0) {
      setUserTypesList(userTypes);
    }
  }, [userTypes]);

  useEffect(() => {
    if (locationName !== undefined) {
      let location = '';
      location = locationsDropdownList.filter((item) => {
        if (item.name === locationName) {
          return item;
        }
      });
      setLocation(location);
    }
  }, [locationsDropdownList]);

  console.log(locationId);

  useEffect(() => {
    if (userDetails) {
      const details = [];
      details.push(userDetails);
      setUsersDetail(details);
    }
  }, [userDetails]);

  console.log(userDetails);
  console.log(usersDetail);

  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}

      <Header />
      <Sidebar />
      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                {addContacts !== undefined && (
                  <h1 className="page-title">
                    {addContacts ? 'Add Contact' : 'Edit Contact'}
                  </h1>
                )}
                {editUser !== undefined && (
                  <h1 className="page-title">
                    {editUser ? 'Edit User' : 'Add user'}
                  </h1>
                )}
                {/* <div>
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a href="javascript:void(0)">Dashboard</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Add Contact
                    </li>
                  </ol>
                </div> */}
              </div>
              <div className="row">
                <div class="col-xl-12">
                  <div class="card">
                    <div class="card-body">
                      {errorMessage && <Error errorMessage={errorMessage} />}
                      {successMessage && (
                        <Success successMessage={successMessage} />
                      )}
                      <div class="panel panel-primary">
                        <ContactForm
                          userDetails={usersDetail}
                          locationDropdownList={locationsDropdownList}
                          userTypesList={userTypesList}
                          editUser={editUser}
                          addContacts={addContacts}
                          location={locationId}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
